import { useHeatsData } from "components/strategyDashboard/heats/context/HeatsDataContext";
import { useHeatsFilter } from "components/strategyDashboard/heats/context/HeatsFilterContext";
import { MaterialsToggle } from "../common/MaterialsToggle";

export const IgnoreMaterialsToggle = () => {
  const { data, materials } = useHeatsData();
  const { ignoredMaterials, setIgnoredMaterials } = useHeatsFilter();

  const materialOrdering = materials?.map((m) => m.name);

  if (
    !data?.available_ignored_material_sets ||
    data.available_ignored_material_sets.length === 0
  ) {
    return null;
  }

  return (
    <MaterialsToggle
      ignorableMaterialSets={data.available_ignored_material_sets}
      ignoredMaterials={ignoredMaterials}
      setIgnoredMaterials={setIgnoredMaterials}
      materialOrdering={materialOrdering}
    />
  );
};
